import Vue from 'vue'
import store from '@/store'
let KnowledgeTableFatherDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var knowledgeTableFatherDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new KnowledgeTableFatherDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  // instance.vm.loadData()
  console.log('options=', options)
  instance.vm.tmguid = options.tmguid
  instance.vm.show = true
  return instance.vm
}

export default knowledgeTableFatherDlg



// WEBPACK FOOTER //
// ./src/components/knowledgeTableFatherDlg/src/main.js